const FALLBACK_WAREHOUSE_TYPES = [
  { id: "Qendrore", label: "Qendrore" },
  { id: "Rezervim", label: "Rezervim" },
  { id: "Vitrinë", label: "Vitrinë" },
  { id: "Dëmtim", label: "Dëmtim" },
  { id: "Furnizim", label: "Furnizim" },
];

const COUNTRIES = [
  { id: "Shqipëri", label: "Shqipëri" },
  { id: "Kosovë", label: "Kosovë" },
  { id: "Maqedoni e Veriut", label: "Maqedoni e Veriut" },
  { id: "Mali i Zi", label: "Mali i Zi" },
  { id: "Greqi", label: "Greqi" },
  { id: "Itali", label: "Itali" },
  { id: "Gjermani", label: "Gjermani" },
];

function val(wa, key, fallback = "") {
  if (!wa) return fallback;
  const value = wa[key];
  return value == null || value === "" ? fallback : value;
}

function flag(wa, key, fallback = 0) {
  if (!wa) return fallback;
  return Number(wa[key]) === 1 ? 1 : 0;
}

const CONTACT_TYPE_NAMES = new Set(["telefon", "email"]);

function warehouseTypeOptions(warehouses, current) {
  const seen = new Set();
  const options = [];
  FALLBACK_WAREHOUSE_TYPES.forEach((item) => {
    seen.add(item.id);
    options.push(item);
  });
  (warehouses || []).forEach((row) => {
    const name = (row.warehouse_type || "").toString().trim();
    if (!name || seen.has(name)) return;
    seen.add(name);
    options.push({ id: name, label: name });
  });
  if (current && !seen.has(current)) {
    options.unshift({ id: current, label: current });
  }
  return options;
}

function allowedContactTypes(types) {
  return (types || []).filter((type) =>
    CONTACT_TYPE_NAMES.has(String(type.label || type.name || "").trim().toLowerCase())
  );
}

function allowedContactRows(rows, types) {
  const allowedIds = new Set((types || []).map((type) => String(type.id)));
  return (Array.isArray(rows) ? rows : []).filter((row) => allowedIds.has(String(row.type_id)));
}

export default function warehouseKartelaForm({
  mode,
  wa,
  cities,
  contact_details,
  main_unit,
  facility,
  warehouses,
  warehouse_categories,
  warehouses_selected_categories,
  warehouse_transit,
  selected_transit_warehouses,
  users,
  roles,
  priority_order,
}) {
  const isEdit = mode === "edit";
  const uniqueWhere = isEdit
    ? [{ column: "guid", condition: "!=", value: wa.guid }]
    : [];
  const contacts = allowedContactTypes(contact_details);

  return {
    name: "Kartelë Magazinë",
    layout: "kartela",
    submit: {
      label: isEdit ? "Ruaj" : "Krijo",
      action: "submitWarehouse",
    },
    fields: [
      { type: "section-header", name: "sec_base", label: "Të dhënat bazë", icon: "fa-regular fa-file-lines" },
      [
        {
          value: val(wa, "code"),
          name: "code",
          label: "Kodi",
          type: "text-field",
          required: true,
          required_text: "Kjo fushe eshte e detyrueshme",
          unique: { model: "warehouse", field: "code", where: uniqueWhere },
          style: "min-width: 18%",
          placeholder: "p.sh. REZ_QE",
        },
        {
          value: val(wa, "name"),
          name: "name",
          label: "Emri i magazinës",
          type: "text-field",
          style: "min-width: 22%",
          required: true,
          required_text: "Kjo fushe eshte e detyrueshme",
          placeholder: "Shkruaj emrin e magazinës",
        },
        {
          value: val(wa, "description"),
          name: "description",
          label: "Përshkrimi",
          type: "text-field",
          style: "min-width: 22%",
          placeholder: "Shkruaj përshkrimin",
        },
        {
          value: val(wa, "kind"),
          name: "kind",
          label: "Lloji (Prod/Aset)",
          type: "select-field",
          options: [
            { id: "prod", label: "Prod" },
            { id: "aset", label: "Aset" },
          ],
          style: "min-width: 16%",
        },
        {
          value: isEdit ? flag(wa, "active") : 1,
          name: "active",
          label: "Aktive",
          style: "min-width: 10%",
          type: "checkbox-field",
          variant: "switch",
        },
      ],

      { type: "section-header", name: "sec_org", label: "Organizimi dhe përgjegjësia", icon: "fa-solid fa-sitemap" },
      [
        {
          value: val(wa, "role"),
          name: "role",
          label: "Roli",
          type: "select-field",
          options: roles,
          style: "min-width: 22%",
          required: !isEdit,
        },
        {
          value: val(wa, "person_in_charge"),
          name: "person_in_charge",
          label: "Personi përgjegjës",
          type: "select-field",
          options: users,
          style: "min-width: 22%",
        },
        {
          value: val(wa, "warehouse_type"),
          name: "warehouse_type",
          label: "Tipi i magazinës",
          type: "select-field",
          options: warehouseTypeOptions(warehouses, val(wa, "warehouse_type")),
          style: "min-width: 22%",
        },
      ],
      [
        {
          value: val(wa, "business_unit"),
          name: "business_unit",
          label: "Njësia kryesore",
          type: "select-field",
          options: main_unit,
          selected_options: [],
          style: "min-width: 18%",
        },
        {
          value: val(wa, "warehouse_facility"),
          name: "warehouse_facility",
          label: "Objekti i magazinës",
          type: "select-field",
          options: facility,
          selected_options: [],
          style: "min-width: 18%",
          required: true,
          required_text: "Kjo fushe eshte e detyrueshme",
        },
        {
          value: val(wa, "priority_order"),
          name: "priority_order",
          label: "Rendi i prioritetit",
          type: "select-field",
          options: priority_order,
          style: "min-width: 18%",
        },
        {
          value: val(wa, "staff_count", 1),
          name: "staff_count",
          label: "Nr. personeli",
          type: "number-field",
          style: "min-width: 12%",
        },
        {
          value: val(wa, "reservation_warehouse"),
          name: "reservation_warehouse",
          label: "Magazina e rezervimit",
          type: "select-field",
          options: (warehouses || []).filter((w) => Number(w.warehouse_facility) === 2 && (!wa || w.guid !== wa.guid)),
          selected_options: [],
          style: "min-width: 22%",
          vif: [{ field: "warehouse_facility", value: 1 }],
        },
      ],

      { type: "section-header", name: "sec_cat", label: "Kategorizimi dhe përcaktimi", icon: "fa-solid fa-tags" },
      [
        {
          name: "type_id",
          label: "Kategoria",
          type: "tree-select",
          style: "min-width: 100%",
          max_height: "420px",
          options: warehouse_categories,
          selected_options: warehouses_selected_categories || {},
          mode: "single",
        },
      ],
      [
        {
          name: "warehouse_transit",
          label: "Pikat e grumbullimit",
          type: "tree-select",
          style: "min-width: 100%",
          max_height: "420px",
          mode: "multiple",
          options: warehouse_transit,
          selected_options: selected_transit_warehouses || {},
          vif: [{ field: "gathering_point", value_not: 1 }],
        },
      ],
      [
        {
          value: flag(wa, "gathering_point"),
          name: "gathering_point",
          label: "Është pikë grumbullimi",
          type: "checkbox-field",
          style: "min-width: 18%",
        },
        {
          value: flag(wa, "can_pickup"),
          name: "can_pickup",
          label: "Pikë dorëzimi për klientët",
          type: "checkbox-field",
          style: "min-width: 18%",
        },
        {
          value: flag(wa, "in_web"),
          name: "in_web",
          label: "Për Web",
          type: "checkbox-field",
          style: "min-width: 12%",
        },
      ],
      [
        {
          value: flag(wa, "allows_transfers"),
          name: "allows_transfers",
          label: "Lejon transferime",
          type: "checkbox-field",
          variant: "switch",
          style: "min-width: 18%",
        },
        {
          value: flag(wa, "invoices"),
          name: "invoices",
          label: "Faturon",
          type: "checkbox-field",
          variant: "switch",
          style: "min-width: 12%",
        },
        {
          value: flag(wa, "allows_purchases"),
          name: "allows_purchases",
          label: "Lejon blerje",
          type: "checkbox-field",
          variant: "switch",
          style: "min-width: 14%",
        },
      ],

      { type: "section-header", name: "sec_loc", label: "Vendndodhja", icon: "fa-solid fa-location-dot" },
      [
        {
          value: val(wa, "location"),
          name: "location",
          label: "Adresa",
          type: "text-field",
          style: "min-width: 28%",
          placeholder: "Shkruaj adresën",
        },
        {
          value: val(wa, "city"),
          name: "city",
          label: "Qyteti",
          type: "select-field",
          options: cities,
          selected_options: [],
          style: "min-width: 18%",
          required: true,
          required_text: "Kjo fushe eshte e detyrueshme",
        },
        {
          value: val(wa, "country", "Shqipëri"),
          name: "country",
          label: "Shteti",
          type: "select-field",
          options: COUNTRIES,
          style: "min-width: 18%",
        },
        {
          value: val(wa, "postal_code"),
          name: "postal_code",
          label: "Zip / Kodi postar",
          type: "text-field",
          style: "min-width: 16%",
          placeholder: "p.sh. 1001",
        },
      ],
      [
        {
          value: val(wa, "latitude"),
          name: "latitude",
          label: "Koordinata (Lat)",
          type: "number-field",
          style: "min-width: 22%",
          placeholder: "Lat",
        },
        {
          value: val(wa, "longitude"),
          name: "longitude",
          label: "Koordinata (Lonq)",
          type: "number-field",
          style: "min-width: 22%",
          placeholder: "Lonq",
        },
        {
          value: val(wa, "area_m2"),
          name: "area_m2",
          label: "Sipërfaqja e magazinës (m²)",
          type: "number-field",
          style: "min-width: 22%",
          placeholder: "p.sh. 1500",
        },
      ],

      { type: "section-header", name: "sec_contacts", label: "Kontaktet", icon: "fa-solid fa-phone" },
      [
        {
          data: allowedContactRows(wa?.contact_details, contacts),
          name: "contact_details",
          label: "",
          type: "multiplexer",
          options: contacts,
          style: "min-width: 100%",
        },
      ],

      { type: "section-header", name: "sec_sync", label: "Konfigurime dhe sinkronizime", icon: "fa-solid fa-gears" },
      [
        {
          value: val(wa, "nipt"),
          name: "nipt",
          label: "NIPT",
          type: "text-field",
          style: "min-width: 30%",
          placeholder: "Shkruaj NIPT-in",
        },
        {
          value: val(wa, "fis_code"),
          name: "fis_code",
          label: "Kodi fiskal",
          type: "text-field",
          style: "min-width: 30%",
          placeholder: "Kodi fiskal F5",
        },
        {
          value: val(wa, "profit_center"),
          name: "profit_center",
          label: "Profit Center",
          type: "text-field",
          style: "min-width: 30%",
          placeholder: "Shkruaj profit center",
        },
      ],
      [
        {
          value: flag(wa, "sync_f1"),
          name: "sync_f1",
          label: "Sink. f1",
          type: "checkbox-field",
          style: "min-width: 18%",
        },
        {
          value: val(wa, "code_f1"),
          name: "code_f1",
          label: "Kodi f1",
          type: "text-field",
          style: "min-width: 40%",
          placeholder: "Shkruaj kodin f1",
        },
      ],
      [
        {
          value: flag(wa, "sync_f2"),
          name: "sync_f2",
          label: "Sink. f2",
          type: "checkbox-field",
          style: "min-width: 18%",
        },
        {
          value: val(wa, "code_f2"),
          name: "code_f2",
          label: "Kodi f2",
          type: "text-field",
          style: "min-width: 40%",
          placeholder: "Shkruaj kodin f2",
        },
      ],
      [
        {
          value: flag(wa, "include_in_cost_revaluation"),
          name: "include_in_cost_revaluation",
          label: "Përfshihet në rivlerësim kostoje",
          type: "checkbox-field",
          style: "min-width: 30%",
        },
      ],
    ],
  };
}
